import { useEffect, RefObject } from 'react';

export const useKonamiCode = (imgRef: RefObject<HTMLImageElement | null>) => {
  useEffect(() => {
    const KONAMI_CODE = [
      'ArrowUp',
      'ArrowUp',
      'ArrowDown',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'ArrowLeft',
      'ArrowRight',
      'b',
      'a',
    ];
    let cursor = 0;
    const handler = (e: KeyboardEvent) => {
      cursor = e.key === KONAMI_CODE[cursor] ? cursor + 1 : 0;
      if (cursor === KONAMI_CODE.length) {
        imgRef.current?.classList.add('animate-spin');
      }
    };
    document.addEventListener('keydown', handler);

    return () => {
      document.removeEventListener('keydown', handler);
    };
  }, [imgRef]);
};
